// extracted by mini-css-extract-plugin
module.exports = {"cartItemList":"CartMergeModal_cartItemList__2Mihs","buttonHolder":"CartMergeModal_buttonHolder__3-OKI","modal":"CartMergeModal_modal__1BFiT","title":"CartMergeModal_title__3QMtW"};